angular.module("requestDataAnticipato.components", []).component("requestDataAnticipato", {
    templateUrl: "ng/components/riscattoAnticipato/requestDataAnticipato/requestDataAnticipato.view.html",
    bindings: {
        richiestePostVendita: "=",
        validateComponent: "&",
        riscattoAnticipato: '<',
        isNavale: '<'
    },
    controllerAs: "reqDataAnticipatoCtrl",
    controller: function RequestDataAnticipato(
        DettaglioImmobiliare,
        Sede,
        $arcService,
        $rootScope,
        RiUserF,
        RiUserG,
        validationService,
        $typeDomainService,
        FileUploader,
        $configService,
        $timeout,
        $financialApiService,
        $download,
        $simulationService
    ) {
        var self = this;

        var initProvince = function () {
            self.supportModel.provinceType = $rootScope.comuniMap
                .map(function (comune) {
                    return comune.sigla;
                })
                .filter(function (siglaComune) {
                    return siglaComune != "";
                })
                .sort()
                .reduce(function (result, nextItem) {
                    return result.includes(nextItem) ? result : result.concat(nextItem);
                }, []);
        };

        self.appContract = {
            numeroContratto: null,
            modulo: null,
            cdBeni: []
        }

        self.contratti = [];

        self.$onInit = function () {
            self.numberContractSelected = 1;
            self.init = true;
            self.supportModel = {
                contractSelected: [],
                contractList: [],
                listToUpdate: [],
                provinceType: [],
                dettaglioList: [],
                testCf: false,
            }

            self.supportModel.listToUpdate = self.richiestePostVendita.metadata.riscattoAnticipato.contratti;
            self.supportModel.listToUpdate.forEach(function (element) {
                if (element.dettaglioImmobiliare.length) {
                    element.selected = true;
                    self.supportModel.dettaglioList = element.dettaglioImmobiliare;
                    // self.supportModel.dettaglioList.importo = self.richiestePostVendita.metadata.ctrRichiestaList[0].importo
                    // self.supportModel.dettaglioList.dscProdotto = self.richiestePostVendita.metadata.ctrRichiestaList[0].dscProdotto
                } else {
                    self.getElencoBeni();
                }
            });

            if (!self.richiestePostVendita.metadata.riscattoAnticipato.riscattoTotale) {
                callRestFromFile();
            }

            initProvince();
            if (self.richiestePostVendita.metadata.riscattoAnticipato.prodottoNav) {

                getAgenzieNav();
            }
            checkValidityComponent();
        };

        self.handleChange = function (property, value) {

            self.richiestePostVendita.metadata.riscattoAnticipato[property] = value;

            switch (property) {
                case "riscattoTerzo":
                    self.richiestePostVendita.metadata.riscattoAnticipato.terzo = RiUserG.build();
                    break;

                case "riscattantePef":
                    self.richiestePostVendita.metadata.riscattoAnticipato.terzo = RiUserF.build();
                    break;

                case "pivaTerzo":
                    if (self.richiestePostVendita.metadata.riscattoAnticipato.terzo) {
                        self.richiestePostVendita.metadata.riscattoAnticipato.terzo.piva = value;
                    }
                    break;

                case "nomeRiscattante":
                    if (self.richiestePostVendita.metadata.riscattoAnticipato.terzo) {
                        self.richiestePostVendita.metadata.riscattoAnticipato.terzo.nome = value;
                    }
                    break;

                case "cognomeRiscattante":
                    if (self.richiestePostVendita.metadata.riscattoAnticipato.terzo) {
                        self.richiestePostVendita.metadata.riscattoAnticipato.terzo.cognome = value;
                    }
                    break;

                case "cfTerzo":
                    if (self.richiestePostVendita.metadata.riscattoAnticipato.terzo) {
                        self.richiestePostVendita.metadata.riscattoAnticipato.terzo.cf = value && value.toUpperCase();
                    }
                    break;

                case "concessionario":
                    self.richiestePostVendita.metadata.riscattoAnticipato.provinciaImmatricolazione = "";
                    break;

                case "agenziaNautica":
                    self.richiestePostVendita.metadata.riscattoAnticipato.agenziaNautica = value;
                    if (value.value == "AGITA") {
                        self.richiestePostVendita.metadata.riscattoAnticipato.opzioniAgenzia = null;
                    }
                    break;

                case "opzioniAgenzia":
                    self.richiestePostVendita.metadata.riscattoAnticipato.opzioniAgenzia = value;
                    break;

                case "riscattoTotale":
                    if (!value) {
                        callRestFromFile();
                    }


                    break;

                default:
                    break;

            }

            checkValidityComponent();
        }

        self.getElencoBeni = function () {
            self.isPending = true;
            self.supportModel.listToUpdate.forEach(function (contratto) {
                self.appContract.numeroContratto = contratto.numero;
                self.appContract.modulo = contratto.modulo;
                self.appContract.cdBeni = [contratto.codProdotto];

                $arcService
                    .getElencoBeni(self.appContract)
                    .then(function (response) {
                        response.forEach(function (element) {
                            var dettaglio = DettaglioImmobiliare.build();
                            dettaglio.numero = contratto.numero;
                            dettaglio.modulo = contratto.modulo;
                            dettaglio.indirizzo = Sede.build(element.indirizzo);
                            dettaglio.indirizzo.luogoEsteso.nome = element.indirizzo.comune;
                            dettaglio.descrizione = element.descrizione;
                            dettaglio.selected = true;
                            dettaglio.codiceBene = element.codiceBene;
                            dettaglio.nrTarga = element.nrTarga;
                            dettaglio.nrTelaio = element.nrTelaio;
                            dettaglio.importo = element.importo
                            dettaglio.dscProdotto = self.richiestePostVendita.metadata.ctrRichiestaList[0].dscProdotto
                            dettaglio.dataFineCtr = element.dataFineCtr
                            contratto.dettaglioImmobiliare.push(dettaglio);
                            self.supportModel.dettaglioList.push(dettaglio);
                        });
                        self.isPending = false;
                    })
                    .catch(function (error) {
                        console.log("ERROR:", error)
                        self.isPending = false;
                    })
            });
            checkValidityComponent();
        }

        self.onCheckboxChange = function () {
            self.richiestePostVendita.metadata.riscattoAnticipato.accettazioneDellaSpesa = !self.richiestePostVendita.metadata.riscattoAnticipato.accettazioneDellaSpesa;
            checkValidityComponent();
        }

        var checkValidityComponent = function () {
            self.richiestePostVendita.metadata.riscattoAnticipato.contratti = self.supportModel.listToUpdate;

            var testContratto = false;
            self.richiestePostVendita.metadata.riscattoAnticipato.contratti.forEach(function (contratto) {
                testContratto = contratto.dettaglioImmobiliare.some(function (dettaglio) {
                    return dettaglio.selected == true
                });
            });

            var riscattoParziale = true;
            if (self.listOfDocument) {
                var testIfFilesUploaded = self.listOfDocument && self.listOfDocument.every(x => {
                    return x.uploadedFiles.length > 0;
                })
                testIfFilesUploaded = testIfFilesUploaded || !self.showSectionUpload;
            }
            if (!self.richiestePostVendita.metadata.riscattoAnticipato.riscattoTotale) {
                riscattoParziale = !!self.richiestePostVendita.metadata.riscattoAnticipato.riscattoParzialeDesc &&
                    (testIfFilesUploaded);
            }

            var testTargato = true;
            if (self.richiestePostVendita.metadata.riscattoAnticipato.prodottoTargato &&
                self.richiestePostVendita.metadata.riscattoAnticipato.riscattoTerzo &&
                !self.richiestePostVendita.metadata.riscattoAnticipato.riscattantePef) {
                testTargato = self.richiestePostVendita.metadata.riscattoAnticipato.pivaTerzo && self.richiestePostVendita.metadata.riscattoAnticipato.cfTerzo;
            } else if (self.richiestePostVendita.metadata.riscattoAnticipato.prodottoTargato &&
                self.richiestePostVendita.metadata.riscattoAnticipato.riscattoTerzo &&
                self.richiestePostVendita.metadata.riscattoAnticipato.riscattantePef) {
                testTargato = self.richiestePostVendita.metadata.riscattoAnticipato.cfTerzo;
            }

            var provImmatricolazione = true;
            if (self.richiestePostVendita.metadata.riscattoAnticipato.riscattoTerzo &&
                !self.richiestePostVendita.metadata.riscattoAnticipato.concessionario) {
                provImmatricolazione = self.richiestePostVendita.metadata.riscattoAnticipato.provinciaImmatricolazione;
            }

            if (self.richiestePostVendita.metadata.riscattoAnticipato.riscattoTerzo &&
                self.richiestePostVendita.metadata.riscattoAnticipato.riscattantePef &&
                self.richiestePostVendita.metadata.riscattoAnticipato.nomeRiscattante &&
                self.richiestePostVendita.metadata.riscattoAnticipato.cognomeRiscattante) {

                self.supportModel.testCf = validationService.checkCfWithName(self.richiestePostVendita.metadata.riscattoAnticipato.cfTerzo, self.richiestePostVendita.metadata.riscattoAnticipato.cognomeRiscattante, self.richiestePostVendita.metadata.riscattoAnticipato.nomeRiscattante);

            } else if (!self.richiestePostVendita.metadata.riscattoAnticipato.riscattantePef) {
                self.supportModel.testCf = true;
            }

            var testNavale = true;
            if (self.richiestePostVendita.metadata.riscattoAnticipato.prodottoNav && self.isNavale) {
                testNavale = !!self.richiestePostVendita.metadata.riscattoAnticipato.agenziaNautica.value &&
                    (!!self.richiestePostVendita.metadata.riscattoAnticipato.opzioniAgenzia || self.richiestePostVendita.metadata.riscattoAnticipato.agenziaNautica.value != 'ALTRO')
            }
            var testContattiClienteImm = true;

            if (self.richiestePostVendita.metadata.riscattoAnticipato.prodottoImm) {
                testContattiClienteImm = testContattiClienteImm &&
                    self.richiestePostVendita.metadata.riscattoAnticipato.contattiCliente &&
                    self.richiestePostVendita.metadata.riscattoAnticipato.contattiCliente.email &&
                    self.richiestePostVendita.metadata.riscattoAnticipato.contattiCliente.telefono &&
                    self.richiestePostVendita.metadata.riscattoAnticipato.contattiCliente.description &&
                    self.richiestePostVendita.metadata.riscattoAnticipato.contattiSopralluogo &&
                    self.richiestePostVendita.metadata.riscattoAnticipato.contattiSopralluogo.email &&
                    self.richiestePostVendita.metadata.riscattoAnticipato.contattiSopralluogo.telefono &&
                    self.richiestePostVendita.metadata.riscattoAnticipato.contattiSopralluogo.description
            }

            if (testContratto && self.richiestePostVendita.metadata.riscattoAnticipato.accettazioneDellaSpesa &&
                riscattoParziale && testTargato && provImmatricolazione && self.supportModel.testCf && testNavale && testContattiClienteImm
            ) {
                self.validateComponent({
                    validity: true
                });
            } else {
                self.validateComponent({
                    validity: false
                });
            }
        }

        var getAgenzieNav = function () {
            self.navalRestRunning = true;
            $typeDomainService
                .getDomainSet("RISC_ANT", "AGENZIE_NAUTICHE")
                .then(function (response) {
                    self.supportModel.agenzieNautiche = response.domainList;
                })
                .catch(function (error) {
                    console.log(error);
                });

            $typeDomainService
                .getDomainSet("RISC_ANT", "ADEMPIMENTI_AGENZIA")
                .then(function (response) {
                    self.supportModel.opzioniAgenzia = response.domainList;
                    self.navalRestRunning = false;
                })
                .catch(function (error) {
                    self.navalRestRunning = false;
                    console.log(error);
                });
        }

        var callRestFromFile = function () {
            self.loaderDocRiscAnt = true;
            $arcService.uploadDocStartRiscAnt(self.richiestePostVendita)
                .then(function (response) {
                    if (response.success) {

                        self.listOfDocument = response.listDocuments;
                    }
                    self.loaderDocRiscAnt = false;
                    self.showSectionUpload = response.visible
                })
                .catch(function (error) {
                    console.log(error);
                    self.loaderDocRiscAnt = false;
                })
        }

        self.uploader = new FileUploader({
            url: "",
            headers: {
                "Access-Control-Allow-Origin": "*",
                Token: "Bearer " + ($configService.getAppConfig().token || "no-token"),
                "App-Name": $rootScope.portalName,
            },
        });

        self.uploadDataFunc = function (item, index) {
            var document =
                arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
            if (item) {
                self.uploadData = item;
            }
            self.uploadDocumenti = document;
            self.currentCodeTypeNameIndex = index;
            self.isSplit = arguments[4] && arguments[4];
            self.singleFile = self.listOfDocument[index];
        };

        self.finalUpload = function () {
            console.log("calling finalUpload");
            self.folderPath = "" + new Date().getTime();
            var url =
                $configService.getAppConfig().url +
                "/uni/upload/service-infos/" +
                "/FINANCIAL-" +
                self.singleFile.cdDocNsil;

            self.disabledForUploadingInProgress = true;
            for (var int = 0; int < self.uploader.queue.length; int++) {
                self.uploader.queue[int].url = url;
            }
            var filesUpload = document.querySelector(
                "#uploadInput_document_" + self.currentCodeTypeNameIndex
            ).files;
            filesUpload = Object.keys(filesUpload).map(function (key) {
                return filesUpload[key];
            });
            var formData = new FormData();

            jQuery("#uploadInput_document_" + self.currentCodeTypeNameIndex).val("");

            filesUpload.forEach(function (file) {
                appendToForm(formData, "file", file);
                appendToForm(formData, "type", "RICHIESTE_CLIENTI");
                appendToForm(formData, "filename", file.name);
                appendToForm(formData, "idPratica", self.richiestePostVendita.id);
                appendToForm(formData, "cdDoc", self.singleFile.cdDocNsil);
                appendToForm(formData, "numeroContratto", self.richiestePostVendita.metadata.riscattoAnticipato.contratti[0].numero);
                appendToForm(formData, "modulo", self.richiestePostVendita.metadata.riscattoAnticipato.contratti[0].modulo);
                appendToForm(formData, "ndgCliente", $configService.getUser().ndg);
                appendToForm(formData, "external", self.singleFile.external);
                appendToForm(formData, "digitale", self.digitalSign);
                $financialApiService
                    .uploadDocOnPv(formData)
                    .then(function (response) {
                        if (response.success) {
                            $timeout(function () {
                                var tmp = {
                                    filename: file.name,
                                    id: response.id,
                                    cdDoc: self.singleFile.cdDocNsil,
                                    downloadKey: response.downloadKey,
                                    status: "1",
                                    selected: false,
                                };

                                self.visualProgBar = false;
                                self.listOfDocument[
                                    self.currentCodeTypeNameIndex
                                ].uploadedFiles.push(tmp);

                                self.listOfDocument[self.currentCodeTypeNameIndex].status = "1";
                                self.disabledForUploadingInProgress = false;
                                checkValidityComponent();
                            }, 1);
                        } else {
                            self.visualProgBar = false;
                            self.disabledForUploadingInProgress = false;
                        }

                    })
                    .catch(function (error) {
                        self.disabledForUploadingInProgress = false;
                        self.visualProgBar = false;
                    });
            });
        };

        self.generateDownloadLink = function (file) {
            if (file.zipMode) {
                return (
                    $configService.getUrl() +
                    "/uni/downloadGenericPv/service-infos/FINANCIAL/" +
                    encodeURIComponent(file.cdDoc) +
                    "/zip/" +
                    encodeURIComponent(self.richiestePostVendita.idWfInstance) +
                    "/?token=" +
                    $configService.getAppConfig().token
                );
            } else {
                return (
                    $configService.getUrl() +
                    "/uni/downloadGenericPv/service-infos/FINANCIAL/" +
                    encodeURIComponent(file.cdDoc) +
                    "/" +
                    encodeURIComponent(file.id) +
                    "/" +
                    encodeURIComponent(self.richiestePostVendita.idWfInstance) +
                    "/?token=" +
                    $configService.getAppConfig().token
                );
            }
        };

        self.uploader.onWhenAddingFileFailed = function (item, filter, options) {
            console.info("onWhenAddingFileFailed", item, filter, options);
        };

        self.uploader.onAfterAddingFile = function (fileItem) {
            console.log("fileItem", fileItem);
            self.disabledForUploadingInProgress = true;
            self.progresso = 0;
            if (fileItem.file.size > 26214400) {
                $rootScope.$broadcast("addAlert", {
                    text: "MAXIMUM_FILE_SIZE_EXCEEDED",
                });
                fileItem.remove();
                jQuery("#uploadInput_document_" + self.currentCodeTypeNameIndex).val("");
            }
            var fileName = fileItem.file.name;
            if (
                fileName.toLowerCase().indexOf(".png") > -1 ||
                fileName.toLowerCase().indexOf(".jpg") > -1 ||
                fileName.toLowerCase().indexOf(".jpeg") > -1 ||
                fileName.toLowerCase().indexOf(".tiff") > -1 ||
                fileName.toLowerCase().indexOf(".pdf") > -1 ||
                fileName.toLowerCase().indexOf(".zip") > -1 ||
                fileName.toLowerCase().indexOf(".p7m") > -1
            ) {
                self.uploader.queue[0].progress = 100;

                self.visualProgBar = true;

                $timeout(function () {
                    self.progresso = 100;
                }, 500);
            } else {
                fileItem.remove();
                jQuery("#uploadInput_document_" + self.currentCodeTypeNameIndex).val("");
                $rootScope.$broadcast("addAlert", {
                    text: "FORMAT_NOT_SUPPORTED",
                });
                self.disabledForUploadingInProgress = false;
                self.uploadInProgess({
                    uploadInProgess: false,
                });
            }
        };

        self.uploader.onAfterAddingAll = function (addedFileItems) {
            console.info("onAfterAddingAll", addedFileItems);
            self.finalUpload(self.uploadData);
        };

        self.uploader.onBeforeUploadItem = function (item) {
            item.file.name = window.encodeURIComponent(item.file.name);
            item.headers["Token"] = "Bearer " + $configService.getAppConfig().token;
            self.disabledForUploadingInProgress = true;
        };

        self.uploader.onProgressItem = function (fileItem, progress) {
            self.uploadCompleted = false;
        };

        self.uploader.onProgressAll = function (progress) { };

        self.uploader.onSuccessItem = function (fileItem, response, status, headers) {

        };

        self.uploader.onErrorItem = function (fileItem, response, status, headers) {
            console.info("onErrorItem", fileItem, response, status, headers);
            jQuery("#uploadInput_document_" + self.currentCodeTypeNameIndex).val("");

            $rootScope.$broadcast("addAlert", {
                text: "ERROR_UPLOADING_FILE",
            });

            self.disabledForUploadingInProgress = false;

            $timeout(function () {
                self.visualProgBar = false;
            }, 1);

            fileItem.remove();
            jQuery("#uploadInput_document_" + self.currentCodeTypeNameIndex).val("");
        };

        self.uploader.onCancelItem = function (fileItem, response, status, headers) {
            console.log(status);
        };

        self.uploader.onCompleteItem = function (
            fileItem,
            response,
            status,
            headers
        ) {
            console.info("onCompleteItem", fileItem, response, status, headers);
            if (
                response &&
                response.uploadFileServicePojo &&
                response.uploadFileServicePojo.success
            ) {
                self.uploadOk = true;
                console.log(fileItem);

                var document = {
                    fileStatus: null,
                    isSelected: false,
                    nameFile: response.uploadFileServicePojo.fileName,
                    uuid: "",
                    errorMessage: "",
                    documentClass: "",
                };

                self.listOfDocument = response.metadataUniUpload.uploadedfile.sort(
                    function (a, b) {
                        if (a.cdDocNsil > b.cdDocNsil) {
                            return 1;
                        } else {
                            return -1;
                        }
                    }
                );
            }
            self.uploader.queue = [];

            $timeout(function () {
                self.visualProgBar = false;

                self.disabledForUploadingInProgress = false;
            }, 1);
            jQuery("#uploadInput_document_" + self.currentCodeTypeNameIndex).val("");
        };

        self.uploader.onCompleteAll = function () {
            console.info("onCompleteAll");
            self.uploadCompleted = true;
        };

        self.uploader.onSuccessItem = function (fileItem, response, status, headers) {
            self.uploading = false;
        };

        self.deleteDocument = function (index) {
            self.progresso = 100;

            self.visualProgBar = true;

            $timeout(function () {
                self.progresso = 0;
            }, 200);

            self.documentsToBeDeleted = self.listOfDocument[index].uploadedFiles.filter(
                function (elem) {
                    return elem.isSelected == true;
                }
            );

            self.documentsToBeDeleted.forEach(function (element) {

                $simulationService
                    .deleteChecklistFilePv(element.id)
                    .then(function (response) {
                        console.log(response);
                        $timeout(function () {
                            self.visualProgBar = false;
                            self.listOfDocument[index].uploadedFiles = self.listOfDocument[
                                index
                            ].uploadedFiles.filter(function (elem) {
                                return elem.isSelected != true;
                            });
                            if (self.listOfDocument[index].uploadedFiles.length == 0) {
                                self.listOfDocument[index].status = "0";
                            }
                            checkValidityComponent();
                        }, 1);
                    })
                    .catch(function (error) {
                        $rootScope.$broadcast("addAlert", {
                            text: "ERROR_TEC",
                        });

                    });
            });


        };

        self.check = function (el) {
            el.isSelected = !el.isSelected;
        };

        self.trashCanEnabledDoc = function (index) {
            return (
                self.listOfDocument[index] &&
                self.listOfDocument[index].uploadedFiles &&
                self.listOfDocument[index].uploadedFiles.some(function (element) {
                    return element.isSelected == true;
                })
            );
        };

        self.downloadFile = function (file) {
            var input = {
                downloadKey: file.downloadKey
            }
            var url = "/uni/downloadDocPv/service-infos/"
            $download.getGenericDownload(url, input)
                .then(function (response) {
                    console.log(response)
                })
        }

        self.handleChangeContattiCli = function (name, value) {
            self.richiestePostVendita.metadata.riscattoAnticipato.contattiCliente[name] = value;
            checkValidityComponent();

        }

        self.handleChangeContattiSopralluogo = function (name, value) {
            self.richiestePostVendita.metadata.riscattoAnticipato.contattiSopralluogo[name] = value;
            checkValidityComponent();

        }


    }
});